import { Injectable } from '@angular/core';
import { BaseService } from '../base/base.service';
import { ContentFactory, Content } from '../../squidex';
import { Observable } from 'rxjs';
import { AppToken } from "../../../models/app-token";

@Injectable({
    providedIn: 'root'
})
export class PageCategoryService extends BaseService {

    constructor(contentFactory: ContentFactory) {
        super(AppToken.PAGE_CATEGORY_SCHEMA_NAME, contentFactory);
    }

    getFirstContent(): Observable<Content> {
        this.initialize();
        return this.contentService.getFirstContent();
    }

}
